import React, { useEffect, useRef } from "react";
import {
  Box,
  CardMedia,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";
import Colors from "assets/Style/Colors";
import {
  FontFamily,
  Images,
  InvoiceGlobal,
  InvoiceLocation,
  InvoiceMail,
  InvoicePhone,
} from "assets";
import styled from "@emotion/styled";
import { CommaSeparator } from "utils";
import moment from "moment";
import LogoImage from "assets/Images/header_voucher.svg";
import { makeStyles } from "@mui/styles";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.openSans,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.openSans,
    textAlign: "center",
    textWrap: "nowrap",

    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.openSans,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));
const useStyle = makeStyles({
  headingBg: {
    margin: "32px 0px",
    padding: "12px 0px",
    textAlign: "center",
  },
  heading: {
    color: Colors.white,
    textTransform: "uppercase",
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  text: {
    color: Colors.smokeyGrey,
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  tableCell: {
    backgroundColor: Colors.aliceBlue,
    border: "0.25px solid #D9D9D9",
    "& .MuiTypography-root": {
      padding: "4px 12px",
    },
  },
});
function SpecialDiscountInvoice({ originalData, onDone }) {
  const contentRef = useRef(null);
  const calculateTotalDiscount = () => {
    return originalData
      .reduce((total, item) => {
        return total + parseFloat(item?.discount || 0);
      }, 0)
      .toFixed(2);
  };

  useEffect(() => {
    if (!originalData) return;

    setTimeout(async () => {
      const node = contentRef.current;
      if (!node) return;

      await document.fonts.ready;

      const canvas = await html2canvas(node, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.7);

      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [1000.08, 677.52],
        compress: true,
      });

      pdf.addImage(imgData, "PNG", 0, 0, 1000.08, 677.52);

      const blob = pdf.output("blob");
      const file = new File(
        [blob],
        `specialDiscount-ref-${originalData?.[0]?.reference_no}.pdf`,
        { type: "application/pdf" }
      );

      onDone?.(file);
    }, 600);
  }, [originalData]);

  return (
    <Container>
      <div ref={contentRef}>
        <Box>
          <Box>
            <Grid container spacing={0}>
              <Grid item xs={3.5} sm={3.5} md={3.5}>
                <Box
                  component={"img"}
                  src={LogoImage}
                  sx={{ width: "100%", alignItems: "center" }}
                />
              </Grid>
              <Grid item xs={8.5} sm={8.5} md={8.5}>
                <CardMedia image={Images.invoiceHeader} sx={{ mb: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{ py: 3, textAlign: "center", color: Colors.white }}
                  >
                    Galaxy Used Cars Tr. LLC
                  </Typography>
                </CardMedia>
                <Grid
                  container
                  spacing={1.5}
                  alignItems={"center"}
                  justifyContent={"space-evenly"}
                >
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoicePhone />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        +971 6 510 2000
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceMail />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        info@galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceGlobal />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        https://galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceLocation />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        Ind Area#4 P.O Box 83126, Sharjah , UAE
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={{ p: 5 }}>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} sm={12} display={"flex"} gap={1}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.openSans,
                      mb: 2,
                    }}
                  >
                    Special Discount
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Grid item sm={7} sx={{ flexDirection: "column" }}>
                    <Grid item sm={12}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          Credit To -{" "}
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          {originalData?.[0]?.creditCustomer?.name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          Processing Date:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          {moment(originalData?.[0]?.created_at).format(
                            "DD-MM-YYYY"
                          )}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          Customize Date:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                          {moment(originalData?.[0]?.date).format("DD-MM-YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item md={3} sm={3}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography variant="body1" sx={{ fontWeight: 700 }}>
                        Ref No:
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 700 }}>
                        {originalData?.[0]?.reference_no ?? "-"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item sm={12}>
                  <TableContainer
                    component={Paper}
                    sx={{
                      boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                      borderRadius: 2,
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <Cell>Customer Name</Cell>
                          <Cell>VIN</Cell>
                          <Cell>LOT</Cell>
                          <Cell>Model/Make</Cell>
                          <Cell>$Discount</Cell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {originalData.map((item, index) => {
                          return (
                            <Row key={index}>
                              <Cell>{item?.booking?.customer?.name}</Cell>
                              <Cell>{item?.booking?.vin}</Cell>
                              <Cell>{item?.booking?.lot_number}</Cell>
                              <Cell>
                                {item?.booking?.veh_model?.name}
                                {"-"}
                                {item?.booking?.veh_make?.name}
                              </Cell>

                              <Cell>{item?.discount}</Cell>
                            </Row>
                          );
                        })}

                        {/* Total Row */}
                        <Row>
                          <Cell colSpan={4}>
                            <b>Total Discount</b>
                          </Cell>
                          <Cell
                            colSpan={4}
                            sx={{ width: "130px", fontWeight: "bold" }}
                          >
                            $
                            {CommaSeparator(
                              parseFloat(calculateTotalDiscount()).toFixed(2)
                            )}
                          </Cell>
                        </Row>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                ></Grid>
                <Grid item xs={12} sm={8}>
                  <Box
                    sx={{ display: "flex", gap: "5px", alignItems: "center" }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ width: "170px", fontWeight: 700 }}
                    >
                      Notes :
                    </Typography>
                    <Typography variant="body1">
                      {originalData?.[0]?.notes ?? "-"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary }}>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Customer care Contact: Mohammed husni - +971523195682 (Arabic &
                English ) Ardamehr Shoev - +971545836028 (English ,Arabic, Tajik
                & Farsi)
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Ravin abdul kareem - +971528293801 (Kurdish , Arabic & English)
                Magsat Gylyjov - +97158666403 (Turken , Russian & English)
              </Typography>
            </Box>
          </Box>
        </Box>
      </div>
    </Container>
  );
}

export default SpecialDiscountInvoice;
